import React from 'react';

export default function InfoCard({ title, description, image, children, className = '' }) {
  return (
    <div className={`ps-card ${className}`.trim()}>
      {image && (
        <div className="ps-card-media" style={{ marginBottom: '12px' }}>
          {image}
        </div>
      )}
      {title && <h3>{title}</h3>}
      {description && <p>{description}</p>}
      {children}
    </div>
  );
}
